import { z } from 'zod';

export type ScheduleFilterMode = 'all' | 'meetings';

export const SINGLETON_WIDGET_IDS = [
  'upcoming-meetings',
  'todays-routines',
  'yesterdays-meetings',
  'pick-up-where-you-left-off',
  'connect-more-apps',
  'credit-balance',
] as const;

export type SingletonWidgetId = (typeof SINGLETON_WIDGET_IDS)[number];

const baseEntryFields = {
  visible: z.boolean(),
  collapsed: z.boolean(),
  order: z.number(),
};

export const SingletonEntrySchema = z.object({
  kind: z.literal('singleton'),
  type: z.enum(SINGLETON_WIDGET_IDS),
  ...baseEntryFields,
});

export const RoutineIslandEntrySchema = z.object({
  kind: z.literal('pinned-routine'),
  routineId: z.number(),
  ...baseEntryFields,
});

export const WidgetEntrySchema = z.discriminatedUnion('kind', [
  SingletonEntrySchema,
  RoutineIslandEntrySchema,
]);

export type SingletonEntry = z.infer<typeof SingletonEntrySchema>;
export type RoutineIslandEntry = z.infer<typeof RoutineIslandEntrySchema>;
export type WidgetEntry = z.infer<typeof WidgetEntrySchema>;
export type IslandEntry = Exclude<WidgetEntry, SingletonEntry>;

export function widgetEntryKey(entry: WidgetEntry): string {
  return entry.kind === 'singleton'
    ? entry.type
    : `pinned-routine:${entry.routineId}`;
}
